import localforage from "localforage";
import { atom } from "recoil";

export type UpdateState = {
  version: string;
  dismissed: boolean;
};

export const updateOnboardingAtom = atom<UpdateState | null>({
  key: "updateOnboardingState",
  effects: [
    ({ onSet, setSelf, trigger }) => {
      const loadState = async () => {
        try {
          const data = await localforage.getItem<UpdateState>("updateOnboarding");
          data ? setSelf(data) : setSelf(null);
        } catch (error) {
          console.log(error);
          setSelf(null);
        }
      };

      if (trigger === "get") {
        loadState();
      }

      onSet(async (newValue, _oldValue, isReset) => {
        if (isReset) {
          setSelf(null);
          await localforage.removeItem("updateOnboarding");
        } else if (newValue !== undefined) {
          await localforage.setItem("updateOnboarding", newValue);
        }
      });
    },
  ],
});
